import { TableCell, TableRow } from '@mui/material';
import { GridLayout } from 'shared/ui/grid-layout';
import { FileWccInfoDto, INVOICE_TYPE_SUPPLIER, IPagingData } from '@sr/dto';
import { formatShortDate } from 'utils/date-format-helpers';
import { LinkToLegalEntity } from 'shared/ui/links/link-to-legal-entity';
import { LinkToFile } from 'shared/ui/links/link-to-file';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import ManagerSpan from 'shared/ui/manager-span';

type Props = {
  collection: IRemotePagedCollection<FileWccInfoDto>,
  paging?: IPagingData;
  onChangePaging?: (paging: IPagingData) => void;
};

export const WccExportedList = ({ collection, paging, onChangePaging }: Props) => {
  return (
    <>
      <GridLayout<FileWccInfoDto>
        columns={['Файл', 'Наше ЮЛ', 'Кто зарузил', 'Дата загрузки']}
        items={collection.collection.items}
        totalItemsCount={collection.collection.totalItemsCount}
        isLoading={collection.isLoading}
        error={collection.error}
        pagingData={paging}
        onChangePaging={onChangePaging}
        itemRender={(item) =>
          <WccExportedList.Row
            key={item.id}
            wccFile={item} />}
        noItemsText='Список файлов пуст'
      />
    </>);
};


type RowProps = {
  wccFile: FileWccInfoDto,
};

WccExportedList.Row = (props: RowProps) => {
  const { wccFile } = props;

  return (
    <>
      <TableRow key={wccFile.exportedFile.id} >
        <TableCell component="th" scope="row">
          <LinkToFile key = {wccFile.exportedFile.id}
            file={{ id: wccFile.exportedFile.id, fileName: wccFile.exportedFile.fileName, size: Number(wccFile.exportedFile.size) }}
            icon={<FilePresentIcon/>}/>
        </TableCell>
        <TableCell>
          <LinkToLegalEntity legalEntity={wccFile.invoice.type===INVOICE_TYPE_SUPPLIER ? wccFile.invoice.buyer : wccFile.invoice.seller} />
        </TableCell>
        <TableCell>
          <ManagerSpan person={wccFile.exportedFile.uploadedBy} />
        </TableCell>
        <TableCell>
          {formatShortDate(wccFile.exportedFile.createdAt)}
        </TableCell>
      </TableRow>
    </>
  );
};
